import React from 'react';
import {Field, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import Error from '../Error';
import TooltipIcon from '../TooltipIcon';

const FormGroupField = ({field, id, name, label, prepend, tooltip, ...rest}) => {
    const FieldComponent = field || Field;
    return (
        <div className="form-group">
            <label className="col-form-label" htmlFor={id}>
                <FormattedMessage {...label} /> {tooltip && <TooltipIcon message={tooltip} />}
            </label>
            <div className="input-group">
                {prepend && <div className="input-group-prepend"><div className="input-group-text">{prepend}</div></div>}
                <FieldComponent name={name} {...rest} className="form-control" id={id} />
            </div>
            <ErrorMessage name={name}>{(message) => <Error reason={message.key || message} reasonParams={message.params} />}</ErrorMessage>
        </div>
    );
};

export default FormGroupField;
